import React from 'react';
import {Modal, Dialogue, Button, Icon} from '@albert-io/atomic';

type Props = {
  onDismiss: () => void;
};

const HardCapErrorModal = ({onDismiss}: Props) => (
  <Modal ariaLabel='exceeded seat limit' handleClose={onDismiss}>
    {({CloseButtonWrapper, modalContentStyle}) => (
      <Dialogue
        inModal
        hideCloseBtn
        className={`${modalContentStyle} content-tertiary text-center`}
        size='s'
      >
        <div className='mb-x4 text-[48px]'>
          <Icon icon='ban' color='negative' />
        </div>
        <p className='mb-x3'>
          Your school&apos;s license has 0 seats remaining. No further student enrollments possible.
        </p>
        <CloseButtonWrapper className='w-full'>
          <Button variant='outlined' onClick={onDismiss}>
            Dismiss
          </Button>
        </CloseButtonWrapper>
      </Dialogue>
    )}
  </Modal>
);

export default HardCapErrorModal;
